import React from "react";
import { NextPage } from "next";

import Pricelist from "scenes/Pricelist";

const Index: NextPage = () => <Pricelist />;

export default Index;
